import useSEO from "@/components/site/useSEO";
import PageHero from "@/components/site/PageHero";
import { Reveal } from "@/components/site/Reveal";

/* Shared layout for legal pages. Sections styled without the typography plugin. */
export function LegalShell({ title, eyebrow = "Legal", updated, seoTitle, seoDesc, children }) {
  useSEO(seoTitle || `${title} | AYOBELL`, seoDesc);
  return (
    <>
      <PageHero eyebrow={eyebrow} title={title} subtitle={updated ? `Last updated: ${updated}` : undefined} />
      <section className="bg-white py-16 sm:py-24 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto">
          <Reveal>
            <div className="space-y-8 text-slate-600 leading-relaxed">{children}</div>
          </Reveal>
        </div>
      </section>
    </>
  );
}

export function LegalSection({ heading, children }) {
  return (
    <div>
      {heading && <h2 className="font-display font-bold text-xl sm:text-2xl text-slate-900 tracking-tight mb-3">{heading}</h2>}
      <div className="space-y-3 text-[15px]">{children}</div>
    </div>
  );
}

export function LegalNote({ children }) {
  return (
    <p className="text-sm text-slate-500 bg-amber-50 border border-amber-200/70 rounded-xl px-4 py-3">
      <span className="font-semibold text-amber-700">Needs confirmation:</span> {children}
    </p>
  );
}

export const LegalList = ({ items }) => (
  <ul className="space-y-2 list-disc pl-5 text-[15px]">
    {items.map((i) => <li key={i}>{i}</li>)}
  </ul>
);
